export default Object.freeze({
    MALE: 'Male',
    FEMALE: 'Female',
    OTHER: 'Other',
})
